import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface F106 {
  f106_01: string;        // 部門代號 (PK, max 4 chars)
  f106_02: number;        // 單位類別 (1=事業單位, 2=幕僚單位)
  f106_11: string;        // 部門名稱
  f106_12: string;        // 主管代號
  f106_12a: string;       // 主管姓名 (derived)
  f106_13: string;        // 簡碼
  f106_16: boolean;       // 舊代號標記
  f106_17: string;        // 副總代號
  f106_17a: string;       // 副總姓名 (derived)
  f106_24: string;        // 部門等級
  f106_91: string;        // 修改人員代號
  f106_92: string | null; // 修改日期
  f106_93: string;        // 修改時間
}

export interface CreateRequest {
  f106_01: string;
  f106_02: number;
  f106_11: string;
  f106_12: string;
  f106_13: string;
  f106_16: boolean;
  f106_17: string;
  f106_24: string;
}

export interface UpdateRequest {
  f106_02: number;
  f106_11: string;
  f106_12: string;
  f106_13: string;
  f106_16: boolean;
  f106_17: string;
  f106_24: string;
}

export interface ListResponse {
  data: F106[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const deptApi = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/dept', { params });
    return res.data;
  },

  async get(code: string): Promise<F106> {
    const res = await apiClient.get(`/api/dept/${encodeURIComponent(code)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<F106> {
    const res = await apiClient.post('/api/dept', data);
    return res.data;
  },

  async update(code: string, data: UpdateRequest): Promise<F106> {
    const res = await apiClient.put(`/api/dept/${encodeURIComponent(code)}`, data);
    return res.data;
  },

  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/dept/${encodeURIComponent(code)}`);
  },

  async lookupEmployee(code: string): Promise<{ code: string; name: string }> {
    const res = await apiClient.get(`/api/dept/lookup/employee/${encodeURIComponent(code)}`);
    return res.data;
  },
};
